module.exports = __webpack_public_path__ + "img/catskill_creek.e342381c.webp";